export const LINKEDCALENDAR_ENTRY_TYPENAME = "LinkedCalendarEntry";
export const LOCALCACHEFORREMOTECALENDAR_ENTRY_TYPENAME = "LocalCacheForRemoteCalendarEntry";
export const LOCALCALENDAR_ENTRY_TYPENAME = "LocalCalendarEntry";
export const LINKEDCALENDARV2_ENTRY_TYPENAME = "LinkedCalendarEntryV2";
